import { type WorkoutFormat } from "api-client/legacy-trpc";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import {
  type InsertRootExerciseButtonProps,
  type ParentContext,
  getAllowedSectionOptions,
  getParentContext,
} from "src/workouts/AddExerciseOrBlock.shared";
import { ImportSectionDialog } from "src/workouts/ImportSectionDialog";
import { InsertButton } from "src/workouts/LinkUnlinkWorkoutItemsButton";
import { useInsertWorkoutItem } from "src/workouts/useInsertWorkoutItem";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export const InsertRootExerciseButton = observer(
  function InsertRootExerciseButton(props: InsertRootExerciseButtonProps) {
    const workoutEditStore = useWorkoutEditStore();
    const permissions = useWorkoutPermissions();
    const insertWorkoutItem = useInsertWorkoutItem();
    const [importDialogOpen, setImportDialogOpen] = useState(false);

    const parentContext: ParentContext | null = getParentContext(
      workoutEditStore.getWorkoutItemById(props.parentId),
    );

    const { sections } = getAllowedSectionOptions(parentContext);

    function handleAddExercise() {
      insertWorkoutItem(
        workoutEditStore.getNextOrder(props.parentId),
        props.parentId,
        "NORMAL",
      );
    }

    function handleAddSection(format: WorkoutFormat) {
      insertWorkoutItem(
        workoutEditStore.getNextOrder(props.parentId),
        props.parentId,
        "GROUP",
        { format: format, groupType: "WORKOUT" },
      );
    }

    return (
      <div className="flex justify-center">
        <InsertButton
          onInsert={handleAddExercise}
          sections={sections}
          onAddSection={handleAddSection}
          onImportFromLibrary={
            permissions.canImportFromLibrary
              ? () => {
                  setImportDialogOpen(true);
                }
              : undefined
          }
        />
        {permissions.canImportFromLibrary && (
          <ImportSectionDialog
            open={importDialogOpen}
            onOpenChange={setImportDialogOpen}
            insertAt={workoutEditStore.getNextOrder(props.parentId)}
          />
        )}
      </div>
    );
  },
);
